/*
 * @Description: --☀☺☀--
 * @Author: Jhon
 * @Date: 2024-06-25 09:12:58
 * @LastEditors: Jhon
 */
export enum FormActionType {
  Form = 'form',
  Modal = 'modal',
  Dialog = 'dialog',
  Popconfirm = 'popconfirm',
  Drawer = 'drawer',
  Menu = 'menu',
  Table = 'table',
  Tree = 'tree',
  Chart = 'chart',
  Map = 'map',
  File = 'file',
  Query = 'query',
  Other = 'other',
}
export enum FormSize {
  Default = 'default',
  Mini = 'mini',
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}
type FormSizeKey = keyof typeof FormSize
export type FormSizeType = typeof FormSize[FormSizeKey]
export interface Events {
  blur?: (arg?: any) => void
  input?: (arg?: any) => void
  change?: (arg?: any) => void
  focus?: (arg?: any) => void
  click?: (arg?: any) => void
  keypress?: (arg?: any) => void
  [key: string]: any
}
export enum ActionType {
  Add = 'add',
  Edit = 'edit',
  Detail = 'detail',
  Delete = 'delete',
  Submit = 'submit',
  Cancel = 'cancel',
  Reset = 'reset',
  Query = 'query',
  ResetQuery = 'resetQuery',
  Preview = 'preview',
  Download = 'download',
  Upload = 'upload',
  DownloadTemplate = 'downloadTemplate',
  Import = 'import',
  Export = 'export',
  Revert = 'revert',
  Copy = 'copy',
  Paste = 'paste',
  Search = 'search',
  Clear = 'clear',
  Filter = 'filter',
  Sort = 'sort',
  Pagination = 'pagination',
  Expand = 'expand',
  Collapse = 'collapse',
  ExpandAll = 'expandAll',
  CollapseAll = 'collapseAll',
  ToggleCollapse = 'toggleCollapse',
  ToggleExpand = 'toggleExpand',
  ToggleSelection = 'toggleSelection',
  ToggleAllSelection = 'toggleAllSelection',
  SelectAll = 'selectAll',
  DeselectAll = 'deselectAll',
  DeselectAllSelection = 'deselectAllSelection',
  ClearSelection = 'clearSelection',
  ClearAllSelection = 'clearAllSelection',
  BatchDelete = 'batchDelete',
  BatchEdit = 'batchEdit',
  BatchDetail = 'batchDetail',
  Custom = 'custom',
  Menu = 'menu',
  MenuGroup = 'menuGroup',
  BatchCopy = 'batchCopy',
  BatchPaste = 'batchPaste',
  BatchCut = 'batchCut',
  BatchCopyLink = 'batchCopyLink',
  BatchPasteLink = 'batchPasteLink',

}
export type ActionTypeKeys = keyof typeof ActionType
export type ActionTypeValuesByKeys = typeof ActionType[ActionTypeKeys]
export enum DateType {
  Year = 'year',
  Month = 'month',
  Week = 'week',
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Second = 'second',
  Dates = 'dates',
  DateTimeRange = 'datetimerange',
  DateTime = 'datetime',
  DateRange = 'daterange',
  TimeRange = 'timerange',
  MonthRange = 'monthrange'
}
export enum FormType {
  Text = 'text',
  Input = 'input',
  CheckboxGroupCm = 'checkboxGroupCm',
  RadioCm = 'radioCm',
  Textarea = 'textarea',
  Select = 'select',
  SelectGroup = 'selectGroup',
  Cascader = 'Cascader',
  CheckboxGroup = 'checkboxGroup',
  RadioGroup = 'radioGroup',
  Radio = 'radio',
  Segmented = 'segmented',
  Switch = 'switch',
  Slider = 'slider',
  Time = 'time',
  TimeSelect = 'timeSelect',
  Date = 'date',
  TimePicker = 'timePicker',
  DatePicker = 'datePicker',
  Upload = 'upload',
  UploadFile = 'uploadFile',
  Rate = 'rate',
  Cascade = 'cascade',
  Transfer = 'transfer',
  InputNumber = 'inputNumber',
  Collapse = 'collapse',
  Form = 'form',
  Tabs = 'tabs',
  Steps = 'steps',
  DynamicForm = 'dynamicForm',
  Dynamic = 'dynamic',
  DynamicFormItem = 'dynamicFormItem',
  UploadList = 'uploadList',
  Tree = 'tree',
  TransferList = 'transferList',
  CascadeSelect = 'cascadeSelect',
  DynamicTable = 'dynamicTable',
  DynamicTableColumn = 'dynamicTableColumn',
  DynamicTree = 'dynamicTree'
}
export interface Props {
  value?: string | number
  label?: string
}
export interface DictDataProps extends Props {
  [key: string]: any
}
export interface Dynamic { }
export interface DynamicTable extends Dynamic { }
export interface DynamicTree extends Dynamic { }
export interface DynamicTableColumn extends Dynamic { }

export interface InputOpt { }
export interface InputNumberOpt { }
export interface TimeOpt { }
export interface CheckboxGroupOpt { }
export interface CheckboxOpt { }
export interface SwitchOpt { }
export interface RateOpt { }
export interface DateOpt { }
export interface SelectOpt { }

export interface ColOpt {
  [key: string]: any
}
export interface Rule {
  required?: boolean
  message?: string
  trigger?: ('blur' | 'change' | string)[]
  validator?: any
  pattern?: RegExp
  custom: object,
  [key: string]: any
}
// 参考element-plus的el-row的配置
export interface RowOpt { }

export interface FormOpt {
  cancelText?: string
  cancelBtnOpt?: { disabled:boolean, [key: string]: any}
  confirmBtnOpt?: { disabled:boolean, [key: string]: any}
  confirmText?: string
  skipSubmitMsg?: boolean
  [prop: string]: any
}
//  TODO: 表单的各个类型的
export interface FormItemOpt { }
export interface RowOpt { }
export interface ActionColOpt { }
export interface CollapseOpt { }
export interface TabsOpt { }
export interface OpeRowOpt { }
export interface FormItemPopoverOpt { }
// 全局配置类型
export interface GlobalOpt {
  required?: boolean
  [prop: string]: any
}
export interface ModelModifiers {
  trim?: boolean,
  lazy?: boolean,
  capitalize?: boolean,
  uppercase?: boolean,
  lowercase?: boolean,
  number?: boolean
}
export interface TabsFormColumns { }
export interface FormItemOpt { }
export interface FormItem<T, K extends keyof T> extends FormItemOpt, GlobalOpt {
  readonly prop?: K
  colOpt?: ColOpt
  globalOpt?: GlobalOpt
  outSearchFiledFlag?: boolean
  label?: string
  dateType?: DateType
  rowOpt?: RowOpt
  modelModifiers?: ModelModifiers,
  readonly value?: any
  required?: boolean
  slot?: boolean
  disabledPopover?:boolean
  formItemPopoverOpt?: FormItemPopoverOpt
  disabled?: () => boolean
  hidden?: () => boolean
  rowAdd?: (done: (form: T) => void) => void
  rowDel?: (row: T, done: () => void) => void
  placeholder?: string
  labelSlot?: boolean
  footerSlot?: boolean
  tip?: string
  tipOpt?: Object
  hiddenAllLabel?: boolean
  events?: Events,
  type?: FormType
  dictData?: DictDataProps[] | { [key: string]: any }
  inputNumOpt?: InputNumberOpt
  rateOpt?: RateOpt
  inputOpt?: InputOpt
  readonly props?: Props
  options?: DictDataProps | string | number[]
  timeOpt?: TimeOpt
  dateOpt?: DateOpt
  switchOpt?: SwitchOpt
  checkboxGroupOpt?: CheckboxGroupOpt
  checkboxOpt?: CheckboxOpt
  selectOpt?: SelectOpt,
  rules?: Rule[]
  columns?: FormItem<T, K>[] | ObjectFormItem<T, K>
  [key: string]: any
}
export interface GroupFormColumns<T, K extends keyof T> {
  title: string, name: string, label: string
  formColumns: FormItem<T, K>[] | ObjectFormItem<T, K>
}
export interface FormItemArray<T, K extends keyof T> {
  [key: number]: FormItem<T, K>[]
}
export type ObjectFormItem<T, K extends keyof T> = {
  [P in K]: FormItem<T, P>
}
export type Form<T,K extends keyof T> = {
  [P in K]: T[P]
}
export type FormKeys = keyof Form<any,any>
